export const config = {
  shortenUrlWorkerUrl: "https://peter-roulette-shorten.skate2.workers.dev",
} as const;
